/**
 * @fileoverview Task status type options (MOR-696)
 *
 * The four workflow "types" a firm-defined status can map to. Shared between
 * the Task Statuses manager (settings) and the quick-add dialog used in the
 * task side-panel status dropdown so both surfaces describe types identically.
 */

import type { TaskStatusType } from "@cvx/tasks/taskStatuses/schema";

export const STATUS_TYPE_OPTIONS: ReadonlyArray<{
  value: TaskStatusType;
  label: string;
  hint: string;
}> = [
  {
    value: "unstarted",
    label: "Backlog / To do",
    hint: "Default landing state",
  },
  { value: "started", label: "In progress", hint: "Actively being worked" },
  {
    value: "completed",
    label: "Completed",
    hint: "Done — excluded from overdue",
  },
  {
    value: "canceled",
    label: "Canceled",
    hint: "Not doing it — excluded from overdue",
  },
];
